export default __webpack_public_path__ + "b2038899b6604de48fa16b11e392cc0c.svg";